import React from 'react'
import { useTranslation } from 'react-i18next'
import Avatar from '@mui/material/Avatar'

import AnalyticsIcon from '@mui/icons-material/Analytics';
import StatisticCard from '@/components/ui/cards/StatisticCard'

import colors from '@/assets/scss/_themes-vars.module.scss'

type ExamStatisticProps = {
  total: number
}

export function ExamStatistic(props: ExamStatisticProps) {
  const { total } = props
  const { t } = useTranslation()

  return (
    <StatisticCard
      icon={(
        <Avatar sx={{ backgroundColor: colors.green500 }}>
          <AnalyticsIcon />
        </Avatar>
      )}
      title={t('page.home.statistic.totalExams.title')}
      value={total}
    />
  )
}

export default ExamStatistic
